/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `FireTv.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { FireTv } from "./FireTv";

import { User } from "./User";

export abstract class FireTvModel {
    id: number;
    accessToken: string | null;
    connectCode: string | null;
    connectCodeExpiresAt: Dayjs | null;
    createdAt: Dayjs;
    tvUuid: string | null;
    updatedAt: Dayjs;
    userId: number | null;
    user: User | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        accessToken: string | null,
        connectCode: string | null,
        connectCodeExpiresAt: Dayjs | null,
        createdAt: Dayjs,
        tvUuid: string | null,
        updatedAt: Dayjs,
        userId: number | null,
        user: User | null | undefined
    ) {
        this.id = id;
        this.accessToken = accessToken;
        this.connectCode = connectCode;
        this.connectCodeExpiresAt = connectCodeExpiresAt;
        this.createdAt = createdAt;
        this.tvUuid = tvUuid;
        this.updatedAt = updatedAt;
        this.userId = userId;
        this.user = user;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): FireTv {
        const newObject = new FireTv(
            json["id"],
            json["access_token"],
            json["connect_code"],
            json["connect_code_expires_at"] ? dayjs(json["connect_code_expires_at"]).tz(timezone) : null,
            dayjs(json["created_at"]).tz(timezone),
            json["tv_uuid"],
            dayjs(json["updated_at"]).tz(timezone),
            json["user_id"],
            json["user"] == null ? json["user"] : User.fromApiObject(json["user"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            access_token: this.accessToken,
            connect_code: this.connectCode,
            connect_code_expires_at: this.connectCodeExpiresAt,
            created_at: this.createdAt,
            tv_uuid: this.tvUuid,
            updated_at: this.updatedAt,
            user_id: this.userId,
            user_attributes: this.user?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): FireTv {
        const clone = Object.create(this) as FireTv;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
